import { Api } from 'models/services/api';
import { DeleteHeadquartersQuery } from 'models/services/graphql';

import { HeadquartersData } from '../index';

type DataToDelete = {
  id: string;
};

const RequestQuery = `
  mutation DeleteHeadquarters($id: ID!) {
    ${DeleteHeadquartersQuery}
  }
`;

type ResponseData = {
  data: {
    deleteHeadquarters: HeadquartersData
  }
}

class DeleteGql {

  readonly api: Api<ResponseData>;
  readonly document?: HeadquartersData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToDelete): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.deleteHeadquarters;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { DeleteGql };